import React from "react";
import Select from "react-select";
import SpotlightLayout from "../../layouts/SpotlightLayout";
import LineChartLayout from "../../layouts/LineChartLayout";
import metricDefinitions from "../../metricDefinitions";
import { connect } from "react-redux";
import selectFormat from "../selectFormat";

class MedicalMetrics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
    };
  }

  componentDidMount() {
    this.setState((prevState, props) => {
      return {
        selectedOption: {
          value: 0,
          label: `${
            this.filteredMetrics()[0] ? this.filteredMetrics()[0].title : null
          }`,
        },
      };
    });
  }

  generateOptions() {
    // check if certain surveys are enabled here. if so, display them as an option.
    // consider passing in only data for surveys that are approved
    var options = [];
    this.filteredMetrics().map((metric, index) => {
      options.push({ value: index, label: `${metric.title}` });
    });
    return options;
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  filteredMetrics = () => {
    return this.state.metrics
      .filter((metric) => metric.visible == true)
      .filter(
        (metric) => !this.props.hiddenOutcomes.includes(metric.outcome_slug)
      );
  };

  render() {
    const { selectedOption } = this.state;
    return (
      <div>
        <div className="mt-4 col-12">
          <div className="shadow ml-2">
            <div className=" pt-4 p-3 d-flex flex-wrap bg-primary align-items-center justify-content-between h-100">
              <div className="text-align-left title">
                Percent of Clients on Medications
              </div>
              <Select
                className="col-12 col-lg-6 p-0 text-color-black"
                value={selectedOption}
                onChange={this.handleChange}
                options={this.generateOptions()}
              />
            </div>
            {this.filteredMetrics().map((metric, index) => {
              return (
                <LineChartLayout
                  showTitle={false}
                  index={index}
                  visible={selectedOption.value == index}
                  {...this.props}
                  metric={metric}
                  key={index}
                />
              );
            })}
          </div>
        </div>
        <div className="col-12">
          {this.props.standardMetrics
            .filter(
              (metric) =>
                !this.props.hiddenOutcomes.includes(metric.outcome_slug)
            )
            .map((metric, index) => {
              return selectFormat(
                {
                  ...metric,
                  endpoint: metric.endpoint ? metric.endpoint : "demographics",
                },
                index,
                this.props
              );
            })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    selectedOption: { value: 0, label: "" },
    organization_name: state.static.organization_name,
    permissions: state.permissions,
    hiddenOutcomes: state.settings.hiddenOutcomes,
    metrics: metricDefinitions(
      state.static.organization_name,
      state.static.permissions
    )["medical"].metrics,
    standardMetrics: metricDefinitions(
      state.static.organization_name,
      state.static.permissions
    )["medical"].standardMetrics,
  };
}

export default connect(mapStateToProps)(MedicalMetrics);
